import { render, staticRenderFns } from "./ProfileHeaderBackground.vue?vue&type=template&id=0b222bb6&scoped=true&"
import script from "./ProfileHeaderBackground.vue?vue&type=script&lang=ts&"
export * from "./ProfileHeaderBackground.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileHeaderBackground.vue?vue&type=style&index=0&id=0b222bb6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b222bb6",
  null
  
)

export default component.exports